import { getVersionId } from '@databases/database-state';
import { PluginKey } from '@databases/plugins';
import { isPluginEnabled } from '@databases/plugins/helper';

export const canEditContent = (updateEntries: boolean): boolean => {
  if (!updateEntries) {
    return false;
  }

  if (!isPluginEnabled(PluginKey.EDIT_CONTENT)) {
    return false;
  }

  const versionId = getVersionId();

  return !versionId;
};
